import { render, staticRenderFns } from "./RepositoryDetailsDisplay.vue?vue&type=template&id=5bf59750&"
import script from "./RepositoryDetailsDisplay.vue?vue&type=script&lang=js&"
export * from "./RepositoryDetailsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports